<div
    [id]="id()"
    [iqStyleProcessorClassname]="classes()"
    [attr.data-testid]="currentTestId()"
    [attr.data-styleTarget]="id()"
>
    <ng-container *ngTemplateOutlet="controlTemplate"></ng-container>
</div>

<ng-template #controlTemplate>
    @for (control of controls(); track control.id; let i = $index) {
    <iq-style-processor-show-element [rules]="control.rules || []">
        <div
            [iqStyleProcessorClassname]="control.classes"
            [cssClassRules]="control.cssClassRules"
        >
            <div
                [attr.data-testId]="control.id"
                [attr.data-styleTarget]="control.id"
                [attr.data-uitype]="'input-wrapper'"
            >
                @switch (control.type) { @case ('Select') {
                <datiq-select
                    [id]="control.id"
                    [settings]="control | controlLegacySelect"
                    [formGroup]="fg"
                    (optionSelected)="
                        change('control', control, 'value', $event)
                    "
                ></datiq-select>
                } @case('Action'){
                <iq-controls-action-button
                    [id]="control.id"
                    [label]="control.label"
                    (click)="click('control', control)"
                >
                </iq-controls-action-button>
                } @case('Tabs'){
                <iq-control-tab-tabs
                    [id]="control.id"
                    [tabs]="control.tabs"
                    [value]="control.value"
                    [fg]="fg"
                    [name]="control.name"
                    (clicked)="click('control', control)"
                    (changed)="change('control', control, 'value', $event)"
                ></iq-control-tab-tabs>
                } @case('Label'){
                <iq-controls-label
                    [id]="control.id"
                    [label]="control.label"
                ></iq-controls-label>
                }@case('Percent') {
                <iq-control-text-percent
                    [id]="control.id"
                    [disabled]="control.disabled"
                    [fg]="fg"
                    [name]="control.name"
                    (changed)="change('control', control, 'value', $event)"
                    [minValue]="control.minValue || 0"
                    [maxValue]="control.maxValue || 1"
                ></iq-control-text-percent>
                } @case('Integer') {
                <iq-control-text-integer
                    [id]="control.id"
                    [disabled]="control.disabled"
                    [fg]="fg"
                    [name]="control.name"
                    (changed)="change('control', control, 'value', $event)"
                    [minValue]="control.minValue || 0"
                    [maxValue]="control.maxValue || 9999"
                ></iq-control-text-integer>
                }@case('Currency'){
                <iq-control-text-currency
                    [id]="control.id"
                    [disabled]="control.disabled"
                    [fg]="fg"
                    [name]="control.name"
                    [value]="control.value"
                    (changed)="change('control', control)"
                    [minValue]="control.minValue"
                    [maxValue]="control.maxValue"
                    [suffix]="control.suffix"
                    [prefix]="control.prefix"
                ></iq-control-text-currency>
                }@case ('Geo') {
                <iq-control-text-geo
                    [id]="control.id"
                    [label]="control.label"
                    [disabled]="control.disabled"
                    [required]="control.required"
                    [fg]="fg"
                    [name]="control.name"
                    [value]="control.value"
                    (changed)="change('control', control, 'value', $event)"
                ></iq-control-text-geo>
                }@case('Reset'){
                <iq-controls-reset-button
                    [id]="control.id"
                    [fg]="fg"
                    [label]="control.label"
                    (resetted)="
                        reset('control', control, 'initialValue', $event)
                    "
                ></iq-controls-reset-button>
                }@case('Submit'){
                <iq-controls-submit-button
                    [id]="control.id"
                    [fg]="fg"
                    [label]="control.label"
                    (submitted)="submit('control', control)"
                ></iq-controls-submit-button>
                }@case('Checkbox'){
                <iq-control-checkbox-control
                    [id]="control.id"
                    [name]="control.name"
                    [checkedLabel]="control.checkedLabel"
                    [uncheckedLabel]="control.uncheckedLabel"
                    [tooltipHeader]="control.tooltipHeader"
                    [tooltipBody]="control.tooltipBody"
                    [fg]="fg"
                    [value]="control.value"
                    [disabled]="control.disabled"
                ></iq-control-checkbox-control>
                }@default { } }
            </div>
        </div>
    </iq-style-processor-show-element>
    }
</ng-template>
